import { useContext, useEffect, useMemo } from "react";
import { Box, CircularProgress, Link, Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { observer } from "mobx-react-lite";
import { SelectRatingStep } from "./Steps/SelectRatingStep";
import ReviewContext from "context/ReviewContext";
import { ReviewStep } from "./Steps/ReviewStep/ReviewStep";
import { ThanksBadStep } from "./Steps/ThanksBadStep";
import { GeoserviceLikeStep } from "./Steps/GeoserviceLikeStep";
import { ThanksLikeStep } from "./Steps/ThanksLikeStep";
import { useNavigate, useParams } from "react-router-dom";
import { FETCH_STATUS } from "descriptions";
// import ErrorCard from "components/ErrorCard/ErrorCard";
import LanguageContext from "context/LanguageContext";

const useStyles = makeStyles()((theme: Theme) => ({
	wrapper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		height: "100svh",
	},
	loading: {
		width: "100vw",
		height: "100svh",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	content: {
		flex: 1,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	footer: {
		padding: theme.spacing(1),
		display: "flex",
		justifyContent: "center",
	},
}));

export const ReviewPage = observer(() => {
	const { classes } = useStyles();
	const navigate = useNavigate();
	const { getTranslate } = useContext(LanguageContext);
	const { step, fetchLocationData, fetchLocationDataService, location } = useContext(ReviewContext);
	const { hash } = useParams<{ hash: string }>();

	const getReviewStep = useMemo(() => {
		switch (step) {
			case 0:
				return <SelectRatingStep hash={hash || ""} />;
			case 1:
				return <ReviewStep hash={hash || ""} />;
			case 2:
				return <ThanksBadStep />;
			case 3:
				return <GeoserviceLikeStep hash={hash || ""} />;
			case 4:
				return <ThanksLikeStep />;
			default:
				return null;
		}
	}, [step]);

	useEffect(() => {
		if (hash) {
			fetchLocationData(hash).then(({ status }) => {
				if (status === FETCH_STATUS.FAILED) {
					navigate("/");
				}
			});
		}
	}, [hash]);

	useEffect(() => {
		if (location?.name) {
			document.title = getTranslate("title", { locationName: location.name });
		}
	}, [location?.name]);

	if (
		fetchLocationDataService.loading === FETCH_STATUS.PENDING ||
		fetchLocationDataService.loading === FETCH_STATUS.WAIT
	) {
		return (
			<Box className={classes.loading} data-testid="loading-wrapper">
				<CircularProgress />
			</Box>
		);
	}

	// if (fetchLocationDataService.loading === FETCH_STATUS.FAILED) {
	// 	return (
	// 		<Box className={classes.loading}>
	// 			<ErrorCard onRefresh={() => window.location.reload()} />
	// 		</Box>
	// 	);
	// }

	return (
		<Box className={classes.wrapper} data-testid="reviews-wrapper">
			<Box className={classes.content}>{getReviewStep}</Box>
			<Box className={classes.footer}>
				<Typography>
					{getTranslate("poweredBy")}{" "}
					<Link href={location.label.url} target="_blank">
						{location.label.name}
					</Link>
				</Typography>
			</Box>
		</Box>
	);
});
